<div class="d-flex align-items-center justify-content-center analytics-group">
    <canvas id="barChart"></canvas>
</div>  